import React, { useState, useImperativeHandle, forwardRef, useRef } from "react";
import { Constants } from "../../constants/appConstants";
import { CutoffDetails } from "../../models/csos/cutoffDetails";
import { DCCutoffCountResponse } from "../../models/csos/dcCutoffCountResponse";
import { csosApiService } from "../../services/api/csosApiService";
import { dateService } from "../../services/dateService";
import "./DCCutoffCount.css";

interface DCCutoffCountProps {
  onClose: () => void;
}

const DCCutoffCount = forwardRef<{ getDCCutoffData: () => void }, DCCutoffCountProps>(
  ({ onClose }, ref) => {
    const [dcTableData, setDcTableData] = useState<CutoffDetails[]>([]);
    const [noDCCutoffFlag, setNoDCCutoffFlag] = useState(true);
    const okBtnRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => ({
      getDCCutoffData: () => {
        csosApiService.getDCCutoffData().then((res) => {
          if (res.body) {
            const data = res.body as DCCutoffCountResponse;
            if (data.dcCutOffCountRespList !== undefined) {
              setDcTableData(data.dcCutOffCountRespList);
              if (data.dcCutOffCountRespList.length === 0) {
                setNoDCCutoffFlag(false);
              }
            }
            setTimeout(() => okBtnRef.current?.focus(), 0);
          }
        });
      },
    }));

    const handleClose = () => {
      setDcTableData([]);
      setNoDCCutoffFlag(true);
      onClose();
    };

    return (
      <div className="modal-dialog modal-lg dcCutoff-modal-width">
        <div className="modal-content dcCutoff-modal-layout">
          <div className="dcCutoff-header">
            <h6 className="modal-title">{Constants.DC_CUTOFF_COUNT}</h6>
          </div>
          {!noDCCutoffFlag && (
            <div className="no-order">{Constants.DC_CUTOFF_NOORDERS}</div>
          )}
          {noDCCutoffFlag && (
            <div className="modal-body">
              <div className="table-container dcCutoff-table">
                <table className="table table-bordered">
                  <thead className="DC-THeader">
                    <tr>
                      <th className="DC-table-header">
                        {Constants.DC_CUTOFF_TIME} ({dateService.getTimeZoneAbbr()})
                      </th>
                      <th className="DC-table-header">{Constants.DC_CUTOFF_ORDERS}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dcTableData.map((cutoff, idx) => (
                      <tr key={idx}>
                        <td className="cutoff-time">
                          {dateService.localizeDate(cutoff.cutOffTime, "MM/DD/YYYY hh:mm A", "ddd hh:mm A")}
                        </td>
                        <td className="records">{cutoff.orderCount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className="modal-footer DCCutoff-ok">
            <span>
              <input
                type="button"
                value="OK"
                ref={okBtnRef}
                className="btn btn-secondary OK"
                onClick={handleClose}
              />
            </span>
          </div>
        </div>
      </div>
    );
  }
);

export default DCCutoffCount;
